export default "__VITE_ASSET__Bbw7Gd7k__"